import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useMyselfDetails } from "../hooks/useUsers";
import { useSiteInformation } from "../hooks/useSite";
import { v4 as uuidv4 } from "uuid";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [themeColor, setThemeColor] = useState("red");
  const [siteInformation, setSiteInformation] = useState(null);
  const [deviceInformation, setDeviceInformation] = useState({
    deviceID: "",
  });
  const [triggerUserFetch, setTriggerUserFetch] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);
  const [appMode, setAppMode] = useState(localStorage.getItem("appMode"));

  const _user = useMyselfDetails();
  const _siteInformation = useSiteInformation();

  const fetchUser = () => {
    setAuthLoading(true);
    const token = Cookies.get("webapitoken");
    if (token) {
      _user.mutate(undefined, {
        onSuccess: (data) => {
          setUser(data?.data || null);
          setIsAuthenticated(true);
          setAuthLoading(false);
        },
        onError: () => {
          setUser(null);
          setIsAuthenticated(false);
          setAuthLoading(false);
        },
      });
    } else {
      setUser(null);
      setIsAuthenticated(false);
      setAuthLoading(false);
    }
  };

  const fetchSiteInformation = () => {
    _siteInformation.mutate(undefined, {
      onSuccess: (data) => {
        setSiteInformation(data?.data || null);
      },
      onError: () => {
        setSiteInformation(null);
      },
    });
  };

  const fetchDeviceInformation = () => {
    let deviceID = localStorage.getItem("device_id");
    if (!deviceID) {
      deviceID = uuidv4();
      localStorage.setItem("device_id", deviceID);
    }
    setDeviceInformation({
      deviceID: deviceID,
    });
  };

  useEffect(() => {
    fetchUser();
    fetchSiteInformation();
    fetchDeviceInformation();
  }, []);

  useEffect(() => {
    if (triggerUserFetch) {
      fetchUser();
    }
  }, [triggerUserFetch]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = Cookies.get("webapitoken");
      if (!currentToken && isAuthenticated) {
        setUser(null);
        setIsAuthenticated(false);
      } else if (currentToken && !isAuthenticated) {
        fetchUser();
      }
    }, 3000);
    return () => clearInterval(interval);
  }, [isAuthenticated]);

  return (
    <GlobalContext.Provider
      value={{
        user,
        setUser,
        themeColor,
        setThemeColor,
        isAuthenticated,
        setIsAuthenticated,
        siteInformation,
        setSiteInformation,
        deviceInformation,
        setTriggerUserFetch,
        authLoading,
        appMode,
        setAppMode,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);
